<template>
  <div class="xyd-jump-confirm">
    <main class="confirm-content">
      <div class="provider-mark" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <polyline points="3 17 9 11 13 15 21 7" />
          <polyline points="14 7 21 7 21 14" />
        </svg>
      </div>
      <h1>即将进入雨惠融平台</h1>
      <p class="summary">由重庆雨征信用管理有限公司为您提供企业信用查询服务。</p>
      <p class="notice">后续页面由雨惠融平台提供服务。</p>
    </main>
    <footer class="confirm-footer">
      <Button
        text="我已知晓，继续"
        type="danger"
        :disabled="isLoading"
        :loading="isLoading"
        loadingText="跳转中..."
        :click="continueToXyd"
      />
    </footer>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import { checkStatus } from './mixin';

export default {
  name: 'XydJumpConfirm',
  components: {
    Button,
  },
  mixins: [checkStatus],
  computed: {
    isLoading() {
      return this.$store.state.commonForms.Isloading;
    },
  },
  methods: {
    continueToXyd() {
      if (this.isLoading) {
        return;
      }
      const orderId = this.$route.query.orderId
        || this.$store.state.commonForms.orderId
        || localStorage.getItem('orderId');
      if (!orderId) {
        this.$toast('未获取到订单信息，请返回后重试');
        return;
      }
      this.$store.dispatch('commonForms/nextJumpPage', { orderId });
    },
  },
};
</script>

<style scoped>
.xyd-jump-confirm {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  color: #202329;
  background: #f7f7f9;
}

.confirm-content {
  box-sizing: border-box;
  flex: 1;
  padding: 154px 24px 100px;
}

.provider-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  margin: 0 auto 32px;
  color: #ff6a3d;
  border: 3px solid #ff6a3d;
  border-radius: 50%;
}

.provider-mark svg {
  width: 49px;
  height: 49px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

h1 {
  margin: 0;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
}

.summary {
  max-width: 330px;
  margin: 18px auto 0;
  color: #a4a6aa;
  font-size: 16px;
  line-height: 1.65;
  text-align: center;
}

.notice {
  max-width: 330px;
  margin: 34px auto 0;
  color: #a4a6aa;
  font-size: 14px;
  line-height: 1.8;
  text-align: center;
}

.confirm-footer {
  padding: 14px 9px calc(24px + env(safe-area-inset-bottom));
}

@media (max-height: 620px) {
  .confirm-content {
    padding-top: 90px;
  }
}
</style>
